
define('text!modules/footer/footer_template.html',[],function () { return '<div class="panel">\r\n  <p>\r\n    <%= _.t(\'footer.text\') %>\r\n  </p>\r\n</div>\r\n';});

